/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useRef, useCallback, useContext } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';

import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';
// import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './_AgGrid.scss'
import './_AgGridStatus.scss'




import { categoriaTemplate, checkBoxTemplate, estadoTemplate, textCenterTemplate } from '../../../Services/TemplatesServices';
import { classNames } from 'primereact/utils';
import Loader from '../../Loader/Loader';
import Icon from '../../Icon/Icon';
import IconApp from '../../Icon/IconApp';
import { formatCodigoProveedor } from '../../../Services/Format';
import { Button } from 'primereact/button';
import { ConfigContext } from '../../../Context/ConfigContext/ConfigContext';
import AutocompleteEditor from './EditorsAg/AutoCompleteEditor';
import { getDateString, getDateStringCeros, getDateTimeString, getDateTimeString24, getDateTimeStringSQL } from '../../../Services/Moment/Luxon';
import { formatNumber, formatNumberDecimal } from '../../../Services/FormatTemplate';
import { Tag } from 'primereact/tag';
import { Chip } from 'primereact/chip';
import { Calendar } from 'primereact/calendar';
import { excelStyles } from './AgGridUtils';
import { SplitButton } from 'primereact/splitbutton';

class DatePicker {
    // gets called once before the renderer is used

    value = ''
    init(params) {
        // create the cell
        this.eInput = document.createElement('input');
        this.eInput.value = params.value;
        this.eInput.classList.add('ag-input');
        this.eInput.style.height = '100%';
        this.eInput.type = 'date'
        this.value = params.value;


        // https://jqueryui.com/datepicker/
        //   $(this.eInput).datepicker({
        //     dateFormat: 'dd/mm/yy',
        //     onSelect: () => {
        //       this.eInput.focus();
        //     },
        //   });
    }

    // gets called once when grid ready to insert the element
    getGui() {
        return this.eInput;
    }

    // focus and select can be done after the gui is attached
    afterGuiAttached() {
        this.eInput.focus();
        this.eInput.select();
    }

    // returns the new value after editing
    getValue() {
        return this.eInput.value === '' ? this.value : (this.eInput.value + ' 00:00:01');
    }

    // any cleanup we need to be done here
    destroy() {
        // but this example is simple, no cleanup, we could
        // even leave this method out as it's optional
    }

    // if true, then this editor will appear in a popup
    isPopup() {
        // and we could leave this method out also, false is the default
        return false;
    }
}
class NumberPicker {
    // gets called once before the renderer is used

    value = ''
    init(params) {
        // create the cell
        this.eInput = document.createElement('input');
        this.eInput.value = params.value;
        this.eInput.classList.add('ag-input');
        this.eInput.style.height = '100%';
        this.eInput.style.width = '100%';
        this.eInput.type = 'number'
        this.value = params.value;


        // https://jqueryui.com/datepicker/
        //   $(this.eInput).datepicker({
        //     dateFormat: 'dd/mm/yy',
        //     onSelect: () => {
        //       this.eInput.focus();
        //     },
        //   });
    }

    // gets called once when grid ready to insert the element
    getGui() {
        return this.eInput;
    }

    // focus and select can be done after the gui is attached
    afterGuiAttached() {
        // this.eInput.focus();
        // this.eInput.select();
    }

    // returns the new value after editing
    getValue() {
        return parseFloat(this.eInput.value)
    }

    // any cleanup we need to be done here
    destroy() {
        // but this example is simple, no cleanup, we could
        // even leave this method out as it's optional
    }

    // if true, then this editor will appear in a popup
    isPopup() {
        // and we could leave this method out also, false is the default
        return false;
    }
}

const filterParams = {
    excelMode: 'windows',
    // treeList: true,
    applyMiniFilterWhileTyping: true,
    buttons: ['clear', 'reset'],
    defaultOption: 'contains',
    filters: [
        {
            filter: 'agTextColumnFilter',
            filterParams: {
                // buttons: ['reset'],
                defaultOption: 'contains',
                caseSensitive: false,
                suppressAndOrCondition: true,
                filterOptions: ['contains', 'notContains', 'equals', 'notEqual', 'startsWith', 'endsWith'],
            },
        },
        {
            filter: 'agSetColumnFilter',
            filterParams: {
                // buttons: ['reset'],
                applyMiniFilterWhileTyping: true,
                defaultOption: 'contains',
            },
        }
    ]
}


function AgGrid({ table }) {


    const tableRef = useRef(null);

    const { config } = useContext(ConfigContext);


    let filterTable = Object.keys(tableRef?.current?.api ? tableRef?.current?.api.getFilterModel() : {});


    const [columns, setColumns] = useState([]);
    const [pinnedBottomRowData, setPinnedBottomRowData] = useState([{ Price: 15 }]);
    const [colTotales, setColTotales] = useState([]);

    const columnTypes = useMemo(() => {
        return {
            numberColumn: { filter: 'agNumberColumnFilter' }, // apply number filter and use agNumberColumnParams as default params
            medalColumn: { width: 100, columnGroupShow: 'open', filter: false }, // remove filter because we will use it as a group
            nonEditableColumn: { editable: false },
            dateColumn: {
                // specify we want to use the date filter
                filter: 'agDateColumnFilter',
                // add extra parameters for the date filter
                filterParams: {
                    // provide comparator function
                    comparator: (filterLocalDateAtMidnight, cellValue) => {
                        // In the example application, dates are stored as dd/mm/yyyy
                        // We create a Date object for comparison against the filter date

                        const dateParts = cellValue.slice(0, -9).split('-');
                        const day = Number(dateParts[2]);
                        const month = Number(dateParts[1]) - 1;
                        const year = Number(dateParts[0]);
                        const cellDate = new Date(year, month, day);
                        // Now that both parameters are Date objects, we can compare
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        } else if (cellDate > filterLocalDateAtMidnight) {
                            return 1;
                        } else {
                            return 0;
                        }
                    },
                },
            },
            IdCustomer: {
                filter: 'agTextColumnFilter',
                cellRenderer: (data) => <div className='divFullCenter'>{formatCodigoProveedor(data.value)}</div>,
                filterParams: {
                    textMatcher: ({ filterOption, value, filterText }) => {
                        const valueLowerCase = formatCodigoProveedor(value).toLowerCase();
                        const filterTextLowerCase = filterText.toLowerCase();
                        switch (filterOption) {
                            case 'contains':
                                return valueLowerCase.indexOf(filterTextLowerCase) >= 0;
                            case 'notContains':
                                return valueLowerCase.indexOf(filterTextLowerCase) === -1;
                            case 'equals':
                                return valueLowerCase === filterTextLowerCase;
                            case 'notEqual':
                                return valueLowerCase !== filterTextLowerCase;
                            case 'startsWith':
                                return valueLowerCase.indexOf(filterTextLowerCase) === 0;
                            case 'endsWith':
                                var index = valueLowerCase.lastIndexOf(filterTextLowerCase);
                                return index >= 0 && index === (valueLowerCase.length - filterTextLowerCase.length);
                            default:
                                // should never happen
                                console.warn('invalid filter type ' + filterOption);
                                return false;
                        }
                    }
                },
            },
        };
    }, []);


    const defaultColDef = useMemo(() => {
        return {
            sortable: true,
            resizable: true,
            floatingFilter: table?.hideFilter ? false : true,
            undoRedoCellEditing: true,
            undoRedoCellEditingLimit: 20,
            redoCellEditing: true,
            filterParams: filterParams,
        };
    }, []);


    const onBtStartEditing = useCallback(
        (key, char, pinned) => {
            tableRef.current.api.setFocusedCell(0, table.Columns[0].field, pinned);
            tableRef.current.api.startEditingCell({
                rowIndex: 0,
                colKey: table.Columns[0].field,
                // set to 'top', 'bottom' or undefined
                rowPinned: pinned,
                key: key,
                charPress: char,
            });
        },
        []
    );


    const setType = (col) => {
        let type = [];
        switch (col?.Format) {
            case 'Currency':
                type = ['rightAligned', 'numberColumn'];
                break;
            case 'Decimal':
                type = ['rightAligned', 'numberColumn'];
                break;
            case "DateTime":
                type = ['rightAligned'];
                break;
            case "Date":
                type = ['rightAligned'];
                break;
            case "IdCustomer":
                type = ['IdCustomer', 'rightAligned'];
                break;
            case 'Template':
                type = col?.Type;
                break;
            case 'Right':
                type = ['rightAligned'];
                break;
            case 'Porcentaje':
                type = ['rightAligned'];
                break;
            default:
                break;
        }
        // console.log(type);
        return type;
    }

    const setCheckbox = (data, col) => {
        if (data.value !== undefined) {
            return (<div className='divFullCenter'>
                {checkBoxTemplate({
                    value: col?.valueFunction ? col.valueFunction(data) : ( data.value ? true : false ) ,
                    disabled: col.Disabled ? col.Disabled(data) : col.disabled,
                    onChange: col.onChange, // (e, {data}) (e, values) ====> values.value, values.data
                    rowData: data,
                    setDisable: col.setDisable,
                    // tooltip: (col.Disabled ? col?.Disabled(data) : col.disabled) ? '' : col?.tooltip
                    tooltip: (col?.tooltip ? col?.tooltip(data) : '')
                })}
            </div>)
        } else {
            return null
        }
    }

    const setEstado = (item, col) => {
        const estado = col.body(item.data)
        return estadoTemplate(estado.ID, estado.Estado);
    }

    const setCategoria = (item, col) => {
        const categoria = col.body(item.data)
        return categoriaTemplate(categoria.ID, categoria.Nombre);
    }

    const setModal = (item, col) => {
        return (<div style={{ fontSize: '0.9rem', lineHeight: '1rem', paddingTop: 5, fontWeight: '600' }} onDoubleClick={() => table?.showModal(item.value)}>
            {textCenterTemplate(item.value)}
        </div>)
    }

    const setIcon = (item, col) => {
        return (<div className='divFullCenter'>
            <Icon icon={item.value ? item.value : ''} />
        </div>)
    }

    const setIconApp = (item, col) => {
        return (<div className='divFullCenter'>
            <IconApp icon={item.value ? item.value : ''} />
        </div>)
    }

    const PorcentajeFormatter = (params) => {
        if (params.value) {
            return params.value + '%'
        } else {
            return ''
        }
    }

    const filterDatesParams = {
        ...filterParams,
        comparator: (filterLocalDateAtMidnight, cellValue) => {
            const dateAsString = cellValue;
            if (dateAsString == null) {
                return 0;
            }
            const date = new Date(dateAsString);
            const dia = date.getDate();
            const mes = date.getMonth();
            const anio = date.getFullYear();
            const fecha = new Date(anio, mes, dia, 0, 0, 0);
            if (fecha < filterLocalDateAtMidnight) {
                return -1;
            } else if (fecha > filterLocalDateAtMidnight) {
                return 1;
            }
            return 0;
        }
    }

    const setBotones = ({ data, node }, column) => {
        if (column.field !== undefined && Object.keys(data).length > 0) {
            return <div className='divFullCenter'>
                {column.Botones.map((boton) => {
                    return <div style={{ width: 38 }}>
                        <Button
                            icon={boton?.icon}
                            className={boton?.className}
                            tooltip={boton?.tooltip}
                            tooltipOptions={{ position: boton?.tooltipOptions?.position || 'right' }}
                            onClick={() => boton?.onClick ? boton?.onClick(data) : undefined}
                            // disabled={boton?.disable ? boton.disable(data) : false}
                            disabled={boton?.disabled ? boton?.disabled(data) : false}
                            hidden={boton?.hidden ? boton?.hidden(data) : false}
                            loading={boton?.loading}
                            text
                        />
                    </div>
                })}
            </div>
        } else {
            return <div className='divFullCenter'>
            </div>

        }
    }

    const setSplitButton = ({ data, node }, column) => {
        if (column.field !== undefined && Object.keys(data).length > 0) {
            return (
                <div className='divFullCenter'>
                    {column.Botones.map((boton) => {
                        const items = boton?.items ? boton.items.map((item) => ({
                            label: item.label,
                            icon: item.icon,
                            command: () => item?.onClick ? item.onClick(data) : undefined
                        })) : [];

                        return (
                            <div>
                                <SplitButton
                                    icon={boton?.icon}
                                    className={boton?.className}
                                    tooltip={boton?.tooltip}
                                    tooltipOptions={{ position: boton?.tooltipOptions?.position || 'right' }}
                                    disabled={boton?.disable ? boton.disable(data) : false}
                                    hidden={boton?.hidden ? boton.hidden(data) : false}
                                    onClick={() => boton?.onClick ? boton?.onClick(data) : undefined}
                                    model={items}  // Aquí agregas los ítems al SplitButton
                                    text
                                />
                            </div>
                        );
                    })}
                </div>
            );
        } else {
            return <div className='divFullCenter'></div>;
        }
    };


    const valueFormatter = (col) => {
        if (col?.Format) {
            switch (col.Format) {

                case 'Botones':
                    return { cellRenderer: (e) => setBotones(e, col), };
                case 'Modal':
                    return { cellRenderer: setModal, };

                case 'Checkbox':
                    return { cellRenderer: (e) => setCheckbox(e, col) };

                case 'Estado':
                    return { cellRenderer: (data) => setEstado(data, col) };

                case 'Dias':
                    return { cellRenderer: (data) => <span className={classNames('text-success text-success text-center col-12 ms-4', { 'text-danger': data.value > 90 })}>{data.value}</span> };

                case 'DateTime':
                    return { valueFormatter: (params) => params.value ? getDateTimeString(new Date(params.value)) : "", type: setType(col), filter: 'agDateColumnFilter', filterParams: filterDatesParams };

                case 'DateTime24':
                    return { valueFormatter: (params) => params.value ? getDateTimeString24(new Date(params.value), true) : "", type: setType(col), filter: 'agDateColumnFilter', filterParams: filterDatesParams };
                case 'Date':
                    return { valueFormatter: (params) => params.value ? getDateStringCeros(new Date(params.value)) : "", type: setType(col), filter: 'agDateColumnFilter', filterParams: filterDatesParams };

                case 'Currency':
                    return {
                        valueFormatter: (params) => (col?.prefix ? col.prefix : '') + ' ' + (params.value ? formatNumberDecimal(params.value) : '0.00') + ' ' + (col?.suffix ? col.suffix : ''),
                        filter: col?.filter === false ? undefined : 'agNumberColumnFilter',
                        // filter: col.filter ? 'agNumberColumnFilter' : undefined,   
                        // cellClass: 'currencyFormat' ,
                        // type: ['rightAligned'] ,
                        type: setType(col),
                    };

                case 'CustomCurrency':
                    return { valueFormatter: (params) => (col?.prefix ? col.prefix : '') + ' ' + (params.value ? formatNumberDecimal(params.value) : '0.00') + ' ' + (col?.suffix ? col.suffix : ''), type: setType(col), filter: col.filter ? 'agNumberColumnFilter' : undefined };

                case 'Decimal':
                    return {
                        valueFormatter: (params) => (col?.prefix ? col.prefix : '') + ' ' + (params.value ? formatNumber(params.value) : '0.0000') + ' ' + (col?.suffix ? col.suffix : ''),
                        filter: col.filter ? 'agNumberColumnFilter' : undefined,
                        // cellClass: 'decimalFormat',
                        type: setType(col),
                        // type: ['rightAligned', 'numberColumn'],
                    };

                case 'CustomDecimal':
                    return { valueFormatter: (params) => (col?.prefix ? col.prefix : '') + ' ' + (params.value ? formatNumber(params.value) : '0.0000') + ' ' + (col?.suffix ? col.suffix : ''), type: setType(col), filter: col.filter ? 'agNumberColumnFilter' : undefined };

                case 'Center':
                    return { cellRenderer: (data) => textCenterTemplate(data.value), type: setType(col) };

                case 'Template':
                    return { cellRenderer: (data) => col.body(data.data) };

                case 'Icon':
                    return { cellRenderer: setIcon };

                case 'IconApp':
                    return { cellRenderer: setIconApp, };

                case 'Porcentaje':
                    // return { valueFormatter: PorcentajeFormatter, filter: 'agNumberColumnFilter', type: ['rightAligned'] }
                    return { valueFormatter: (params) => (params.value ? formatNumberDecimal(params.value) : (col?.calcFunction ? formatNumberDecimal(col.calcFunction(params)) : '0.00')) + '%', type: setType(col), filter: col.filter ? 'agNumberColumnFilter' : undefined };
                case 'SplitButton':
                    return { cellRenderer: (e) => setSplitButton(e, col), };
                case 'Categoria':
                    return { cellRenderer: (data) => setCategoria(data, col) };
                default:
                    return { valueFormatter: (params) => params.value ? ((col?.prefix ? col.prefix : '') + params.value + (col?.suffix ? col.suffix : '')) : '', type: setType(col) };
            }
        } else {

            return { valueFormatter: (params) => params.value ? ((col?.prefix ? col.prefix : '') + params.value + (col?.suffix ? col.suffix : '')) : '', type: setType(col) };
        }
    };



    const DateTime24Template = (e) => {
        const { value, data, api, colDef, rowIndex, onValueChange } = e;
        const [date, setDate] = useState(new Date(value));
        return <Calendar
            // showTime={true}
            // showSeconds={true}
            // hourFormat='24'
            showIcon={true}
            dateFormat='dd/mm/yy'
            style={{ width: '100%', height: '100%' }}
            showButtonBar={true}
            value={date}
            onChange={
                eventChange => {
                    if (colDef?.changeValiadtion) {
                        const change = colDef.changeValiadtion({ ...eventChange, data, api, colDef })
                        if (change) {
                            setDate(eventChange.value);
                            data[colDef.field] = getDateTimeStringSQL(eventChange.value);
                        } else {
                            setDate(eventChange.value);
                        }
                    } else {
                        setDate(eventChange.value);
                        data[colDef.field] = getDateTimeStringSQL(eventChange.value);
                        data['changed'] = true;
                    }
                    // colDef?.onCellValueChanged ? colDef.onCellValueChanged(e) : (e) => {
                    // setDate(e.value);
                    // data[colDef.field] = getDateTimeStringSQL(e.value);
                }
            }


            onBlur={(e) => {
                api.stopEditing();
            }}
            onHide={(e) => {
                api.stopEditing();
            }}
            on
        />
    }


    const setCellEditor = (col) => {
        if (col?.cellEditor) {
            return {
                editable: col?.editable,
                // cellEditorPopup: true,
                cellEditorSelector: (params) => {
                    return {
                        component: col.cellEditor, onCellValueChanged: col?.onChange
                    }
                },
            }
        }
        switch (col?.Format) {
            case 'Currency':
                return { editable: col?.editable, onCellValueChanged: col?.onChange };

            case "Decimal":
                return { editable: col?.editable, onCellValueChanged: col?.onChange };

            case "DateTime":
                return { editable: col?.editable, cellEditor: DatePicker, onCellValueChanged: col?.onChange };
            case "DateTime24":
                return { editable: col?.editable, cellEditor: DateTime24Template, onCellValueChanged: col?.onChange, changeValiadtion: col?.changeValiadtion };
            case "Date":
                return { editable: col?.editable, cellEditor: DateTime24Template, onCellValueChanged: col?.onChange, changeValiadtion: col?.changeValiadtion };
            case "EditList":
                return {
                    editable: col?.editable,
                    cellEditor: 'agSelectCellEditor',
                    // cellEditorPopup: true,
                    cellEditorParams: col?.cellEditorParam,
                }
            case "AutoComplete":
                return {
                    editable: col?.editable,
                    // cellEditorPopup: true,
                    cellEditorSelector: ({ data, api }) => {
                        return {
                            component: () => {
                                return <AutocompleteEditor
                                    data={data}
                                    value={col?.value}
                                    label={col?.label}
                                    api={api}
                                    items={col?.itemsFilter ? col?.itemsFilter(data) : col?.items}
                                    // items={col?.items}
                                    field={col?.field}
                                    onChange={col?.onChange}
                                />
                            },
                        }
                    },
                }
            default:
                return { editable: col?.editable, onCellValueChanged: col?.onChange };
        }
        return { editable: col?.editable };
    }

    const setWidthColumn = (col) => {
        let width = null;
        const XXXsmall = 25;
        const XXsmall = 35;
        const Xsmall = 85;
        const small = 125;
        const medium = 155;
        const large = 205;
        const Xlarge = 255;
        const XXlarge = 305;
        const XXXlarge = 355;
        const XXXXlarge = 405;

        switch (true) {
            case col?.className?.includes('XXXsmall'):
                width = XXXsmall;
                break;
            case col?.className?.includes('XXsmall'):
                width = XXsmall;
                break;
            case col?.className?.includes('Xsmall'):
                width = Xsmall;
                break;
            case col?.className?.includes('small'):
                width = small;
                break;
            case col?.className?.includes('medium'):
                width = medium;
                break;
            case col?.className?.includes('XXXXlarge'):
                width = XXXXlarge;
                break;
            case col?.className?.includes('XXXlarge'):
                width = XXXlarge;
                break;
            case col?.className?.includes('XXlarge'):
                width = XXlarge;
                break;
            case col?.className?.includes('Xlarge'):
                width = Xlarge;
                break;
            case col?.className?.includes('large'):
                width = large;
                break;
            case col?.className?.includes('flex'):
                width = null;
                break;
            default:
                width = null;
                break;
        }
        if (col.Format === 'DateTime') {
            if (col?.width) {
                width = col.width;
            } else {
                width = medium
            }
            if (col?.flex) {
                width = null;
            }
        }
        if (col.Format === 'Date') {
            if (col?.width) {
                width = col.width;
            }
            else {
                width = 100;
            }
            if (col?.flex) {
                width = null;
            }
        }
        if (col.Format === 'Checkbox') {
            width = 85;
        }
        if (col.Format === 'Botones') {
            width = col.Botones.length * 40;
        }
        return width;
    }


    const setSumary = () => {
        let sumary = ``;
        colTotales.forEach((col) => {
            switch (col.Sumary) {
                case 'sum':
                    let sum = 0;
                    tableRef.current.api.forEachNodeAfterFilter((w) => {
                        if (w.data[col.field]) {
                            // console.log(w.data?.noSumary);
                            if (!w.data?.noSumary) {
                                sum += w.data[col.field];
                            }
                        }
                    })

                    sumary += `"${col.field}": ${sum},`;
                    break;

                case 'count':
                    sumary += ` "${col.field}": ${tableRef.current.api.getDisplayedRowCount()},`;
                    break;

                case 'avg':
                    let summ = 0;
                    let count = 0;
                    tableRef.current.api.forEachNodeAfterFilter((w) => {
                        if (w.data[col.field]) {
                            summ += Number(w.data[col.field]);
                            count++;
                        }
                    })
                    let avg = summ / count;
                    sumary += `"${col.field}": ${avg ? avg : 0},`;
                    break;

                default:

                    sumary += ` "${col.field}": "${col.Sumary}", `;

                    break;
            }

        });
        try {
            const sumaryJson = JSON?.parse('{' + sumary?.slice(0, -1) + '}');
            if (sumaryJson) {
                setPinnedBottomRowData([sumaryJson]);
            }
        } catch (error) {
            console.log('Error al parsear el JSON de totales:', error);
        }
    }

    const setPinnet = (col, width) => {
        const t = document.getElementById('AgGridReact' + table?.key).clientWidth;
        if (t > 800) {
            return col?.alignFrozen ? col.alignFrozen : (col?.frozen ? 'left' : '')
        } else {
            return null;
        }
    }


    const setColumn = (col) => {

        if (col) {
            if (col?.children) {
                let children = []
                col.children.forEach((child) => {
                    const c = setColumn(child)
                    if (child && (child?.hidden === true || child?.hidden === undefined)) {
                        children.push(c)
                    }
                });
                return {
                    headerName: config.language === 'es' ? (col?.headerName ?? '') : (col?.headerNameEn ? col.headerNameEn : col?.headerName),
                    children: children,
                    header: col?.Header,
                }
            } else {

                const width = setWidthColumn(col);

                const Format = valueFormatter(col);

                const cellEditor = setCellEditor(col);
                const pinnet = setPinnet(col, width);

                // console.log(col?.comparator ? 'SI TIENE' : 'NO TIENE', col?.field, col?.comparator);


                return {
                    headerName: config.language === 'es' ? col?.header : (col?.headerEn ? col.headerEn : col?.header),
                    headerTooltip: col?.Tooltip ? col?.Tooltip : col.header,
                    field: col.field,
                    headerClass: col.className,
                    type: col.type,
                    onCellDoubleClicked: col.onCellDoubleClicked,
                    onCellClicked: col.onCellClicked,
                    // type: setType(col),
                    flex: col.flex,
                    width: col?.width ? col.width : width,
                    minWidth: col?.minWidth,
                    hide: col.hidden !== undefined ? !col.hidden : false,
                    filter: col.filter !== false ? 'agMultiColumnFilter' : undefined, // 'agTextColumnFilter', "agMultiColumnFilter", "agSetColumnFilter"
                    sort: col?.sort,
                    filterParams: filterParams,
                    pinned: pinnet,
                    rowGroup: col?.rowGroup,
                    aggFunc: col?.aggFunc,
                    pivot: col?.pivot,
                    enablePivot: col?.enablePivot,
                    pivotComparator: col?.pivotComparator,
                    cellClass: col?.cellClass,
                    cellStyle: col?.cellStyle,
                    comparator: col?.comparator,
                    ...Format,
                    ...cellEditor,
                    // checkboxSelection: (data) => setCheckbox(data, col) ? true : undefined,
                }
            }
        } else {
            return;
        }
    }

    // HOOKS de efecto que retorna la funcion getUsuarios
    useEffect(() => {
        if (table?.Columns.length > 0) {
            let cols = [];
            if (table?.selected && table?.setSelected) {
                cols.push({
                    field: '',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionFilteredOnly: true,
                    suppressSizeToFit: true,
                    suppressMenu: true,
                    suppressSorting: true,
                    suppressFilter: true,
                    pinned: 'left',
                    cellStyle: { 'textAlign': 'center' },
                    width: 50,
                    headerName: '',
                    // headerStyle: { 'textAlign': 'center', color: 'red', },
                    headerComponentParams: {
                        template:
                            `<div class="ag-cell-label-container" role="presentation">
                                <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                                <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                                    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                                    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                                    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                                    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                                    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: nowrap;"></span>
                                    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>   
                                </div>
                            </div>`,
                    },
                })
            }


            const totales = [];

            const setSumarys = (col) => {
                if (col?.Sumary) {
                    totales.push({ field: col.field, Sumary: col.Sumary });
                } else {
                    if (col?.children) {
                        col.children.forEach(setSumarys)
                    }
                }
            }


            table.Columns.forEach((col) => {
                if (col && (col?.hidden === true || col?.hidden === undefined)) {

                    setSumarys(col)
                    cols.push(setColumn(col));
                }

            });

            setColTotales(totales);
            setColumns(cols);
        }
    }, [table, table.Columns]);

    const addRow = () => {
        table?.funcionAddRow()
        //    onBtStartEditing(undefined, undefined, 'bottom')
    }

    const getRowStyle = (params) => {
        if (params.data) {
            return { background: 'green' }
        }
        return { background: 'blue' }
    }


    const EdidMenu = () => {
        if (table?.showEditMenuDefauld) {
            return <div className='d-flex m-1'>
                <span style={{ fontSize: 24, margin: '5px 2px' }}>
                    <Button icon='pi pi-plus' className='p-button-info' onClick={addRow} >
                        {/* <Icon icon='ri-add-line'/> */}
                    </Button>
                </span>
                <span style={{ fontSize: 24, margin: '5px 2px' }}>
                    <Button icon='pi pi-save' className='p-button-success' >
                        {/* <Icon icon='ri-add-line'/> */}
                    </Button>
                </span>
                <span style={{ fontSize: 24, margin: '5px 2px' }}>
                    <Button icon='pi pi-pencil' className='p-button-info' >
                        {/* <Icon icon='ri-add-line'/> */}
                    </Button>
                </span>
                <span style={{ fontSize: 24, margin: '5px 2px' }}>
                    <Button icon='pi pi-times' className='p-button-danger' >
                        {/* <Icon icon='ri-add-line'/> */}
                    </Button>
                </span>

            </div>
        }
        else {
            return <div className='d-flex m-1'>
                {table.showEditMenuCustom}
                {table.showEditMenuCSV && <span className='mx-2' style={{ fontSize: 24, margin: '8px 0px' }}>
                    <Button icon={'pi pi-file-excel'} className='p-button-success' onClick={onBtnExport} >
                        {/* <Icon icon='ri-add-line'/> */}
                    </Button>
                </span>}
            </div>
        }
    }

    const onBtnExport = useCallback(() => {
        tableRef?.current?.api.exportDataAsCsv();
    }, []);




    return (
        <div id={'AgGridReact' + table?.key} className={config?.theme === 'Dark' ? "ag-theme-balham-dark" : "ag-theme-balham"} style={{ height: '100%', flex: 1, fontSize: 10 }}>
            <Loader loading={table?.loading} querySelector={'#AgGridReact' + table?.key} />
            {table?.showEditMenu && <EdidMenu />}
            <div className='pb-1'
                style={{
                    height: table.hideFilter ? '100%' : 'calc(100% - 30px)'
                }}
            >
                <AgGridReact
                    ref={tableRef} // REF PARA ACCEDER A LA TABLA
                    rowData={table.Data} // DATA
                    columnDefs={columns} // COLUMNAS
                    defaultColDef={defaultColDef} // PROPIEDADES POR DEFECTO DE LAS COLUMNAS
                    rowSelection={'multiple'} // SELECCION MULTIPLE
                    columnTypes={columnTypes} // TIPOS DE COLUMNAS
                    suppressRowClickSelection={true} // SUPRIMIR SELECCION DE FILA
                    pinnedBottomRowData={table.pinnedBottomRowData ? table.pinnedBottomRowData : (table?.hideFooter ? null : pinnedBottomRowData)} // FILA DE TOTALES
                    onSelectionChanged={(e) => { table?.setSelected(e.api.getSelectedNodes().map((node) => node.data)) }} // EVENTO DE SELECCION
                    onFilterChanged={setSumary} // EVENTO DE FILTRO
                    onGridReady={setSumary} // EVENTO DE FILTRO
                    onModelUpdated={setSumary} // EVENTO DE FILTRO
                    isRowSelectable={() => true} // FILAS SELECCIONABLES
                    // editType={table?.editType ? table.editType : 'fullRow'}
                    singleClickEdit={true} // UN CLICK PARA EDITAR
                    enableRangeSelection={true} // SELECCION DE RANGO
                    enableRangeHandle={true}
                    onCellClicked={table.onCellClicked}
                    // enterNavigatesVertically={true}
                    enterNavigatesVerticallyAfterEdit={true}
                    undoRedoCellEditing={true}
                    undoRedoCellEditingLimit={20}
                    enableCellChangeFlash={true}
                    enableCharts={true}
                    animateRows={true}
                    alwaysShowHorizontalScroll={true}
                    suppressScrollWhenPopupsAreOpen={true}
                    pivotMode={table.pivotMode}
                    groupDefaultExpanded={table.groupDefaultExpanded}
                    sideBar={table.sideBar}
                    // groupDisplayType={table?.groupDisplayType}
                    groupDisplayType='groupRows'
                    pivotDefaultExpanded={table?.pivotExpanded}
                    pivotRowTotals={table?.pivotRowTotals}
                    pivotPanelShow={table?.pivotPanelShow}
                    excelStyles={[...excelStyles, table?.excelStyles ? table.excelStyles : { id: 'no', dataType: 'String' }]}
                    rowClassRules={table?.rowClassRules ? table?.rowClassRules : null}
                    // ={e => console.log("Drag", e)}
                    onCellFocused={e => {
                        if (table?.onCellFocused) {
                            table?.onCellFocused(e, e.api.getDisplayedRowAtIndex(e.rowIndex).data)
                        }
                        // console.log(e.column.colId, e.api.getDisplayedRowAtIndex(e.rowIndex).data);
                    }
                    }
                // onRowClicked={(e) => console.log('rowClicked', e, e.api.getValue())}
                // onRowSelected={(e => console.log('rowSelected', e))}
                // suppressCellFocus={true}
                // onrow
                // stopEditingWhenCellsLoseFocus={true}
                // unSortIcon

                >
                </AgGridReact>
                {!table.hideFilter && <div className='mt-1 filterBar' style={{}}>
                    {filterTable?.length > 0 && <Button icon='pi pi-filter-slash' text
                        onClick={() => tableRef.current.api.setFilterModel(null)}
                    />}
                    {filterTable.map((i) => {
                        return <Chip className='mx-1' style={{ margin: 1 }} severity='info' label={i} removable onRemove={(e) => {
                            tableRef.current.api.destroyFilter(i);
                            tableRef.current.api.onFilterChanged();
                        }} />
                    })}
                </div>}
            </div>
        </div>
    )
}

export default AgGrid;